module.exports = __webpack_public_path__ + "img/project4_5.19aefd75.jpg";